import React from 'react';
import { Redirect } from 'react-router-dom'
import useReactRouter from 'use-react-router';

function Enter ({setResultKey}){
    //const { history, location, match } = useReactRouter();
    const props = useReactRouter();
	if( props.match.params.key ){
        setResultKey( props.match.params.key );
    }
	return (
		<Redirect to="/" />
	)
}

export default Enter;